import { render, staticRenderFns } from "./PriceLists.vue?vue&type=template&id=7cc12f1a"
import script from "./PriceLists.vue?vue&type=script&lang=js"
export * from "./PriceLists.vue?vue&type=script&lang=js"
import style0 from "./PriceLists.vue?vue&type=style&index=0&id=7cc12f1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports